module.exports = __webpack_public_path__ + "img/replay-button.3996d7c5.png";